import { cn } from '@module/lib/utils';
import formatNumberWithComma from '@module/utils/formatNumberWithComma';

interface Props {
  count: number;
  className?: string;
  label?: string;
  suffix?: string;
}

function TableItemsTotalNumber({ count, className, label = '총 게시물: ', suffix = '건' }: Props) {
  return (
    <p className={cn('text-[#777]', className)}>
      <span>{label}</span>
      <span className='font-semibold text-baseFg'>{formatNumberWithComma(count)}</span>
      <span>{suffix}</span>
    </p>
  );
}

export default TableItemsTotalNumber;
